import { themeBase } from './theme-base';

export const theme = themeBase;
